import { createReduxConstants } from '@bibliocommons/utils-redux';

export const actionTypes = createReduxConstants('ANALYTICS_GA4', {
  TRACK_PAGE_VIEW: null
});

export const eventNames = {
  PAGE_VIEW: 'bc_page_view',
  HOLD_PLACE: 'bc_hold_place'
};

export default {
  actionTypes,
  eventNames
};
